module.exports = __webpack_public_path__ + "static/img/YB-1000.4ab65433.png";